export const menuRankProduct = [
  {id:1, title:"아우터", link:"/men/man-outer", rightMainData:[
      {
        code:"POYWI2450499551001",
        img:"/images/products/POYWI2450499551001/thumbnail.jpg",
        brand:"BOSS",
        title:"후드 패딩 파카 릴렉스핏",
        price: 581000
      }
    ], rank:[
      {
        id: 1,
        code:"POYFA2550543492001",
        img: '/images/products/POYFA2550543492001/thumbnail.jpg',
        brand: 'BOSS',
        title:"디태처블 라이너 패디드 봄버 자켓",
        price: 580000
      }, {
        id: 2,
        code:"POYFA2550543240202",
        img: '/images/products/POYFA2550543240202/thumbnail.jpg',
        brand: 'BOSS',
        title:"클래식 양가죽 블루종 자켓",
        price: 920000
      }, {
        id: 3,
        code:"POYFA2550543388404",
        img: '/images/products/POYFA2550543388404/thumbnail.jpg',
        brand: 'BOSS',
        title:"후드 사파리 점퍼 오버핏",
        price: 468000
      }, {
        id: 4,
        code:"POYSP2550530270001",
        img: '/images/products/POYSP2550530270001/thumbnail.jpg',
        brand: 'BOSS',
        title:"양가죽 봄버 자켓 릴랙스핏",
        price: 611000,
      }
  ]},
  {id:2, title:"펜츠", link:"/women/women-pants", rightMainData:[
      {
        code:"T32F6NEW19TWT11BY",
        img:"/images/products/T32F6NEW19TWT11BY/thumbnail.jpg",
        brand:"TOMMY JEANS",
        title:"미아 루즈 핏 데님 팬츠",
        price: 189000
      }
    ], rank:[
      {
        id: 1,
        code:"T32F7NEW45TWT11BK",
        img: "/images/products/T32F7NEW45TWT11BK/thumbnail.jpg",
        brand: "TOMMY JEANS",
        title:"클레어 와이드 핏 턴업 데님 팬츠",
        price: 199000
      }, {
        id: 2,
        code:"T12F6NPC010MT11BC",
        img: "/images/products/T12F6NPC010MT11BC/thumbnail.jpg",
        brand: "TOMMY HILFIGER MEN",
        title:"덴톤 스트레이트 인디고 데님 팬츠",
        price: 199000
      }, {
        id: 3,
        code:"T32F7WPC16TWT1C1G",
        img: "/images/products/T32F7WPC16TWT1C1G/thumbnail.jpg",
        brand: "TOMMY JEANS",
        title:"스크립트 워시드 스웨트 팬츠",
        price: 169000
      }, {
        id: 4,
        code:"T22F7WPC080WT1ADZ",
        img: '/images/products/T22F7WPC080WT1ADZ/thumbnail.jpg',
        brand: 'TOMMY HILFIGER WOMEN',
        title:"니트 와이드 팬츠",
        price: 469000
      }
  ]},
  {id:3, title:"가방", link:"/sundries/sundries-man-bag", rightMainData:[
      {
        code:"P4W4D3202GUB1",
        img:"/images/products/P4W4D3202GUB1/thumbnail.jpg",
        brand:"Calvin Klein Accessories",
        title:"남성 엠보스드 엠블럼 라운드 백팩",
        price: 219000,
      }
    ], rank:[
      {
        id: 1,
        code:"P8ZHP3A3A01",
        img: '/images/products/P8ZHP3A3A01/thumbnail.jpg',
        brand: 'GUESS',
        title:"아미타_AMITA 스웨이드 배색 호보백",
        price: 219000
      }, {
        id: 2,
        code:"POYWI2550536498001",
        img: '/images/products/POYWI2550536498001/thumbnail.jpg',
        brand: 'BOSS',
        title:"시그니처 오피스 브리프케이스",
        price: 312000
      }, {
        id: 3,
        code:"POYSP2550535706001",
        img: '/images/products/POYSP2550535706001/thumbnail.jpg',
        brand: 'HUGO',
        title:"스퀘어 벨트 백",
        price: 217000
      }, {
        id: 4,
        code:"Q7H0401DC",
        img: '/images/products/Q7H0401DC/thumbnail.jpg',
        brand: 'Magforce',
        title:"아델리 펭귄 웨이스트백 - 데저트 카모",
        price: 98000
      }
  ]},
  {id:4, title:"신발", link:"/men/man-shoes", rightMainData:[
      {
        code:"P4WYM0134401W",
        img:"/images/products/P4WYM0134401W/thumbnail.jpg",
        brand:"Calvin Klein Accessories",
        title:"남성 미네르바 청키 레더 레이스업 컵솔 스니커즈",
        price: 159000
      }
    ], rank:[
      {
        id: 1,
        code:"POYFA2450522833005",
        img: '/images/products/POYFA2450522833005/thumbnail.jpg',
        brand: 'BOSS',
        title:"Aiden 에이든 로우탑 스니커즈",
        price: 175500
      }, {
        id: 2,
        code:"POYSP2550536504001",
        img: '/images/products/POYSP2550536504001/thumbnail.jpg',
        brand: 'BOSS',
        title:"Kieran 키에란 소가죽 로우탑 스니커즈",
        price: 201500
      }, {
        id: 3,
        code:"T52F7ARS130JT1YBI",
        img: '/images/products/T52F7ARS130JT1YBI/thumbnail.jpg',
        brand: 'TOMMY SHOES',
        title:"아카이브 98 웜라인 스니커즈",
        price: 179000
      }, {
        id: 4,
        code:"T52F6ASZ330WT1BDS",
        img: '/images/products/T52F6ASZ330WT1BDS/thumbnail.jpg',
        brand: 'TOMMY SHOES',
        title:"엘레트라 페니 레더 로퍼",
        price: 299000
      }
  ]},
  {id:5, title:"스커트", link:"/women/women-skirt", rightMainData:[
      {
        code:"T22F7WSC050WT1C1G",
        img:"/images/products/T22F7WSC050WT1C1G/thumbnail.jpg",
        brand:"TOMMY HILFIGER WOMEN",
        title:"분또 테일러드 미디 스커트",
        price: 279000
      }
    ], rank:[
      {
        id: 1,
        code:"T22F7WSC505WL1N56",
        img: '/images/products/T22F7WSC505WL1N56/thumbnail.jpg',
        brand: 'TOMMY HILFIGER WOMEN',
        title:"윈터 롱 스커트",
        price: 329000
      }, {
        id: 2,
        code:"T22F7WSC080WT1MR8",
        img: '/images/products/T22F7WSC080WT1MR8/thumbnail.jpg',
        brand: 'TOMMY HILFIGER WOMEN',
        title: "코듀로이 미니 스커트",
        price: 209000
      }, {
        id: 3,
        code:"T22F7WSC060WT1BDS",
        img: '/images/products/T22F7WSC060WT1BDS/thumbnail.jpg',
        brand: 'TOMMY HILFIGER WOMEN',
        title: "울 플리츠 미니 스커트",
        price: 279000
      }, {
        id: 4,
        code:"T22F7WSC061WT10OG",
        img: '/images/products/T22F7WSC061WT10OG/thumbnail.jpg',
        brand: 'TOMMY HILFIGER WOMEN',
        title: "체크 패턴 미니 스커트",
        price: 279000
      }
  ]}
]